import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "references-section",
  id: "references"
}
const _hoisted_2 = { class: "references-grid" }
const _hoisted_3 = { class: "reference-image" }
const _hoisted_4 = { class: "image-overlay" }
const _hoisted_5 = { class: "reference-content" }
const _hoisted_6 = { class: "reference-icon" }
const _hoisted_7 = { class: "reference-category" }

import {ExternalLink, Fence, Hammer, Trees} from "lucide-vue-next";

import "@/assets/styles/reference.css";


export default /*@__PURE__*/_defineComponent({
  __name: 'ReferencesView',
  setup(__props) {

const references = [
  {
    icon: Trees,
    title: "Moderner Familiengarten",
    category: "Gartenpflege & Gestaltung",
    text: "Komplette Neugestaltung eines privaten Gartens inklusive Rollrasen, Bepflanzung und Beleuchtung."
  },
  {
    icon: Fence,
    title: "Sichtschutz & Zaunanlage",
    category: "Sichtschutz",
    text: "Hochwertige Sichtschutzlösung mit langlebigen Materialien für mehr Privatsphäre im Außenbereich."
  },
  {
    icon: Hammer,
    title: "Terrasse & Pflasterarbeiten",
    category: "Pflasterarbeiten",
    text: "Moderne Terrassenfläche mit sauber verlegtem Pflaster und stilvoller Gestaltung."
  }
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "references-header" }, [
      _createElementVNode("span", { class: "section-badge" }, " Referenzen "),
      _createElementVNode("h2", null, " Einblicke in unsere Projekte "),
      _createElementVNode("p", null, " Jedes Projekt wird individuell geplant und professionell umgesetzt – von kleinen Gartenarbeiten bis zu kompletten Außenanlagen. ")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(references, (reference) => {
        return _createElementVNode("div", {
          class: "reference-card",
          key: reference.title
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(ExternalLink))
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(reference.icon)))
            ]),
            _createElementVNode("span", _hoisted_7, _toDisplayString(reference.category), 1),
            _createElementVNode("h3", null, _toDisplayString(reference.title), 1),
            _createElementVNode("p", null, _toDisplayString(reference.text), 1)
          ])
        ])
      }), 64))
    ])
  ]))
}
}

})